/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_TimeInputs */

const en_cargos_time = /** @type {(inputs: Cargos_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time`)
};

const es_cargos_time = /** @type {(inputs: Cargos_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora`)
};

/**
* | output |
* | --- |
* | "Time" |
*
* @param {Cargos_TimeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_time = /** @type {((inputs?: Cargos_TimeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_TimeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_time(inputs)
	return es_cargos_time(inputs)
});